export function set(id: string, action: string) {
  sessionStorage.setItem('lastAction', JSON.stringify({ id, action }))
}

export function get() {
  const entry = sessionStorage.getItem('lastAction')

  if (!entry) {
    return undefined
  }

  const { id, action } = JSON.parse(entry)
  return { id, action }
}

export function remove() {
  sessionStorage.removeItem('lastAction')
}
